module.exports = __webpack_public_path__ + "static/media/32_B.18381b61.png";